
import React, { useState } from "react";
import { LoginForm } from "@/components/auth/LoginForm";
import { SocialLoginButtons } from "@/components/auth/SocialLoginButtons";
import { LoginDivider } from "@/components/auth/LoginDivider";
import { useLoginRedirect } from "@/hooks/useLoginRedirect";
import { useTempUserData } from "@/hooks/useTempUserData";

const Login = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { tempUserData, email, setEmail } = useTempUserData();
  
  // Redirect if already authenticated
  useLoginRedirect();

  return (
    <div className="min-h-screen bg-[#1A1A1A] flex items-center justify-center">
      <div className="w-[90%] max-w-[450px] p-6 mx-auto">
        <h1 className="text-3xl font-bold text-white mb-8 text-center">Login</h1>
        
        <LoginForm 
          email={email} 
          setEmail={setEmail} 
          tempUserData={tempUserData} 
        />
        
        <div className="text-center text-gray-400 text-sm mt-8">
          <p className="mb-4">Noch kein Konto? <a href="/registration" className="text-[#41c7f0] hover:underline">Jetzt registrieren</a></p>
        </div>
        
        <LoginDivider />
        
        <SocialLoginButtons isSubmitting={isSubmitting} />
      </div>
    </div>
  );
};

export default Login;
